import OrderForwardEditRequest, {
  OrderForwardEditRequestBody,
} from "./order-forward-edit.request";

const createBody = (
  request: OrderForwardEditRequest,
): OrderForwardEditRequestBody => {
  return {
    contractId: request.contractId,
  };
};

const orderForwardEditRequestFactory = {
  createBody,
};

export default orderForwardEditRequestFactory;
